import * as ACT from './actions'
import { createReducer } from 'redux-create-reducer'

const initialState = {
  userImage: '',
  address: '',
  logo: '',
  backgroundColor: '#51525e',
  isFetchingLogo: true,
  count: 0
}

const headerReducer = createReducer(initialState, {
  [ACT.GET_LOGGED_IN_USER_FETCH_SUCCESS](state, action) {
    const { loggedInUser } = action.payload

    return {
      ...state,
      address: loggedInUser.address
        ? `${loggedInUser.address} ${loggedInUser.city ? ', ' + loggedInUser.city : ''} ${
            loggedInUser.state ? ', ' + loggedInUser.state : ''
          }`
        : '',
      userImage: loggedInUser.image
    }
  },
  [ACT.GET_LOGO_FETCH_SUCCESS](state, action) {
    const { logo, backgroundColor } = action.payload
    return {
      ...state,
      logo,
      backgroundColor,
      isFetchingLogo: false
    }
  },
  [ACT.REFRESH_HEADER](state) {
    return {
      ...state,
      count: state.count + 1
    }
  }
})

export default headerReducer
